export enum Events {
    TRIP_NOTIFICATIONS = 'tripNotification',
    ONBOARDING_NOTIFICATIONS = 'onboardingNotification',
    CHAT_MESSAGE = 'chat:message',
    CHAT_READ = 'chat:read',
    TICKET_CREATED = 'ticket:created',
    TICKET_UPDATED = 'ticket:updated'
}
